import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import CanvasFormTextAreaValue from '../../CanvasForm/CanvasFormTextAreaValue';
import CanvasFormTextArea from '../../CanvasForm/CanvasFormTextArea';

function MeasurementBasisRationale({
	className,
	financialPeriodAmount,
	isAnnualizedAmountExpectedToBeReported,
	rationale,
	setLastRationaleSaved,
	setRationale,
	updateMateriality,
	onChange,
	onCancel,
	isAresView,
	isDisabled
}) {
	const textAreaName = 'rationale-text-area';

	async function handleOnAccept(value) {
		setRationale(value);
		setLastRationaleSaved(value);

		return updateMateriality(
			financialPeriodAmount,
			value,
			isAnnualizedAmountExpectedToBeReported, //currentMateriality?.helixModel?.isAnnualizedAmountExpectedToBeReported
			textAreaName
		);
	}

	return (
		<StyledMeasurementBasisRationale className={`rationale-input ${className}`}>
			<CanvasFormTextArea
				id="rationaleTextArea"
				name={textAreaName}
				label={labels.enterRationaleAmountDetermined}
				showLabel
				maxLength={4000}
				onAccept={handleOnAccept}
				progressBarClassName="saverationale-loader"
				value={rationale ?? ''}
				onChange={(e) => onChange(textAreaName, rationale, e.target.value)}
				onCancel={() => onCancel(textAreaName)}
				showProgressBar={false}
				isAresView={isAresView}
				disabled={isDisabled}
			>
				<CanvasFormTextAreaValue />
			</CanvasFormTextArea>
		</StyledMeasurementBasisRationale>
	);
}

MeasurementBasisRationale.propTypes = {
	className: PropTypes.string,
	financialPeriodAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isAnnualizedAmountExpectedToBeReported: PropTypes.bool,
	lastRationaleSaved: PropTypes.string,
	rationale: PropTypes.string,
	setLastRationaleSaved: PropTypes.func.isRequired,
	setRationale: PropTypes.func.isRequired,
	updateMateriality: PropTypes.func.isRequired
};

MeasurementBasisRationale.defaultProps = {
	className: 'rationale-container'
};

export default MeasurementBasisRationale;

const StyledMeasurementBasisRationale = styled.section`
	display: flex;
	flex-direction: column;
	position: relative;
	width: inherit;
	margin-bottom: var(--px-10);
	&.rationale-input {
		margin-top: var(--px-24);
		.canvas-form-textarea {
			display: block;
			width: var(--px-600);
			.motif-form-field {
				.StyledCanvasFormInputDisplay {
					.canvas-form-input-display-value {
						padding: 0 0 0 var(--px-12);
						height: 100%;
						line-height: var(--px-22);
						font-size: var(--px-14);
						font-weight: 300;
						position: relative;
						section {
							padding: var(--px-10) var(--px-5) var(--px-5) 0;
						}
					}
				}
			}
			.StyledConfirmInputIcons {
				width: auto;
				z-index: 1;
				.save-btn,
				.cancel-btn {
					.motif-icon {
						svg {
							fill: var(--blue-600);
						}
					}
				}
			}
		}
	}
`;
